import request from './utils/request'

/**
 * 根据企业ID查询会员单位信息
 * @param {Number} entId - 企业ID
 * @returns {Promise} 返回请求结果
 */
export function getMemberUnitInfoByEntId(entId) {
  return request({
    url: '/web/memberUnit/getByEntId',
    method: 'get',
    params: { entId }
  })
}

/**
 * 更新协会会员单位信息
 * @param {Object} data - 会员单位信息
 * @returns {Promise} 返回请求结果
 */
export function updateMemberUnit(data) {
  return request({
    url: '/web/memberUnit/update',
    method: 'post',
    data
  })
}

/**
 * 申请会员单位
 * @param {Object} data - 申请数据
 * @returns {Promise} 返回请求结果
 */
export function applyForMembership(data) {
  return request({
    url: '/web/memberUnit/applyForMembership',
    method: 'post',
    data
  })
}

/**
 * 会员入会理事会投票
 * @param {Object} params - 投票参数
 * @param {Number} params.applicantEnterpriseId - 申请企业的单位ID (businessId)
 * @param {String} params.voteResult - 投票结果 0-反对, 1-赞成
 * @returns {Promise} 返回请求结果
 */
export function voteForMembership(params) {
  return request({
    url: '/web/memberUnit/vote',
    method: 'post',
    params
  })
}

/**
 * 获取投票详情
 * @param {Number} voteRecordId - 投票记录id
 * @returns {Promise} 返回请求结果
 */
export function getVoteDetailsById(voteRecordId) {
  return request({
    url: '/web/memberUnit/getVoteDetailsById',
    method: 'get',
    params: { voteRecordId }
  })
}

/**
 * 根据会员单位类型获取申请节点步骤
 * @param {Number} memberUnitTypeId - 会员单位类型ID
 * @returns {Promise} 返回请求结果
 */
export function getMemberUnitAuditStepByMemberUnitTypeId(memberUnitTypeId) {
  return request({
    url: '/web/memberUnit/getMemberUnitAuditStepByMemberUnitTypeId',
    method: 'get',
    params: { memberUnitTypeId }
  })
}

/**
 * 获取会员单位投票统计结果
 * @returns {Promise} 返回请求结果
 */
export function getMemberUnitVoteResultStatistics() {
  return request({
    url: '/web/memberUnit/getMemberUnitVoteResultStatistics',
    method: 'get'
  })
}

/**
 * 上传缴纳会费凭证
 * @param {String} paymentVoucher - 会费凭证文件URL
 * @returns {Promise} 返回请求结果
 */
export function uploadPaymentVoucher(paymentVoucher) {
  return request({
    url: '/web/memberUnit/uploadPaymentVoucher',
    method: 'post',
    params: { paymentVoucher }
  })
}

/**
 * 查询协会会员单位列表 (门户端公开列表)
 * @param {Object} query - 查询参数
 * @returns {Promise} 返回请求结果
 */
export function listMemberUnits(query) {
  return request({
    url: '/web/memberUnit/listMemberUnits',
    method: 'get',
    params: query
  })
}

/**
 * 检查当前用户是否为在有效期的会员单位
 * @returns {Promise} 返回请求结果
 */
export function memberUnitsPeriodValidity() {
  return request({
    url: '/web/memberUnit/memberUnitsPeriodValidity',
    method: 'get'
  })
}
